import { Upload } from 'lucide-react';

/**
 * File Drop Zone Component
 */
export function FileDropZone({ onDrop, onDragOver, onClick }) {
  return (
    <div
      onDrop={onDrop}
      onDragOver={onDragOver}
      onClick={onClick}
      className="border-2 border-dashed border-slate-300 rounded-xl p-8 text-center cursor-pointer hover:border-slate-400 hover:bg-slate-50 transition-all group"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center group-hover:bg-slate-200 transition-colors">
          <Upload className="w-6 h-6 text-slate-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-slate-700">
            Drag & drop your JSON file here
          </p>
          <p className="text-xs text-slate-500 mt-1">
            or <span className="text-slate-900 font-medium underline">browse</span> to choose a file
          </p>
        </div>
      </div>
    </div>
  );
}
